const slicer = state => state.data.clickDeliver;

export const selectZips = state => slicer(state).zips;
export const selectError = state => slicer(state).error;
